import i18n from 'i18n'

import { GROUP_CUSTOM_ID } from './constants'

import businessImage from './i/business.png'
import educationImage from './i/education.png'

export const mapGroups = groups => {
    const result = []

    groups.forEach(group => {
        if (group.customId === GROUP_CUSTOM_ID.BUSINESS) {
            result.push({
                ...group,
                image: businessImage,
                title: group.groupTranslationDto.text,
                description: i18n.t('Solutions for marketers, media and business'),
            })
        }
        if (group.customId === GROUP_CUSTOM_ID.EDUCATION) {
            result.push({
                ...group,
                image: educationImage,
                title: group.groupTranslationDto.text,
                description: i18n.t('Solutions for teachers, schools and universities'),
            })
        }
    })

    return result
}
